import { style } from '@vanilla-extract/css'

const section = style({
  width: '100%',
  padding: '40px 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
})

const title = style({
  fontSize: '38px',
  fontWeight: '800',
  lineHeight: '1.5',
  color: '#252525',
  padding: '0 24px',
  fontFamily: 'Inter Variable, sans-serif',
  letterSpacing: '0.04em',
})

const subtitle = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#252525',
  padding: '0 24px',
})

export const styles = {
  section,
  title,
  subtitle,
}
